import { STORAGE_KEY } from 'constants/browserStorageKeys';

export const setLocalStorage = (key: STORAGE_KEY, value: any) => {
  return localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key: STORAGE_KEY) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

export const removeLocalStorage = (key: STORAGE_KEY) => {
  localStorage.removeItem(key);
};
